import React from 'react'
import { Route } from "react-router-dom";
import { CLIENT_ROUTES } from "../../config/routes";
import loadable from "@loadable/component";
import CenteredSpinner from "../../components/centered-spinner/CenteredSpinner";

const options =  {
  fallback : <CenteredSpinner />
}

const Projects =  loadable(() => import( /* webpackChunkName: "Projects" */  "../../pages/client/projects/Projects"), options)
const  ProjectDetailMarketResearchFullService = loadable(() => import(/* webpackChunkName: " ProjectDetailMarketResearchFullService" */  "../../pages/client/projects/project-detail/project-detail-mrfsc/ProjectDetailMarketResearchFullService"), options)
const ProjectDetailMarketResearch = loadable(() => import(/* webpackChunkName: "ProjectDetailMarketResearch" */ "../../pages/client/projects/project-detail/project-detail-market-research/ProjectDetailMarketResearch") , options)

export function ProjectsRoutes() {
  return (
    <Route path={CLIENT_ROUTES.PROJECTS}>
      <Route index element={<Projects />} />
        <Route path={`${CLIENT_ROUTES.MARKET_RESEARCH_FULL_SERVICE}/${CLIENT_ROUTES.PROJECT_DETAIL}`} element={<ProjectDetailMarketResearchFullService />} />
        <Route path={`${CLIENT_ROUTES.MARKET_RESEARCH}/${CLIENT_ROUTES.PROJECT_DETAIL}`} element={<ProjectDetailMarketResearch />} />
    </Route>
  )
}
